import { makeAutoObservable, observable, toJS} from "mobx"

class UserStore {
    access_token = null;
    id_token = null;
    lanID = null;
    access = {};
    permissions = []
    roles = []

    constructor() {
        makeAutoObservable(this, {
            access_token: observable,
            id_token: observable,
            lanID: observable,
            access: observable,
        })
    }

    get getAccessToken(){
        return toJS(this.access_token)
    }
    get getIdToken(){
        return toJS(this.id_token)
    }
    get getLanId(){
        return toJS(this.lanID)
    }
    get getAccess(){
        return toJS(this.access)
    }
    get getPermissions(){
        return toJS(this.permissions)
    }
    get getRoles(){
        return toJS(this.roles)
    }

    setAccessToken(access_token){
        this.access_token = access_token
    }
    setIdToken(id_token){
        this.id_token = id_token
    }
    setLanId(lanID){
        this.lanID = lanID
    }
    setAccess(access){
        this.access = access
    }
    setPermissions(permissions){
        this.permissions = permissions
    }
    setRoles(roles){
        this.roles = roles
    }
}

const userStore = new UserStore();

export { userStore }
